module.exports = __webpack_public_path__ + "img/logo-biogen.96de03d3.jpg";